// A photo of what a 3D view shows right now (the in-game camera): the view drawn once more and copied in the
// same moment (a WebGL picture is only there until the browser shows it), scaled to `maxSide` at most and
// made into a JPEG. Only the game's own picture: never the device's camera, never the page around it.
export function snapshotCanvas(canvas: HTMLCanvasElement, draw: () => void, maxSide = 1600): Promise<Blob | null> {
  draw();
  const scale = Math.min(1, maxSide / Math.max(canvas.width, canvas.height, 1));
  const copy = document.createElement('canvas');
  copy.width = Math.max(1, Math.round(canvas.width * scale));
  copy.height = Math.max(1, Math.round(canvas.height * scale));
  copy.getContext('2d')?.drawImage(canvas, 0, 0, copy.width, copy.height);
  return new Promise((resolve) => copy.toBlob(resolve, 'image/jpeg', 0.9));
}
